
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/coach/[coachUsername]/accept",
      function () {
        return require("private-next-pages/coach/[coachUsername]/accept.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/coach/[coachUsername]/accept"])
      });
    }
  